var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-footer",
    [
      _c("v-container", { staticClass: "footer" }, [
        _c(
          "div",
          { staticClass: "footer__top" },
          [
            _c(
              "div",
              { staticClass: "footer__logo" },
              [
                _c("router-link", { attrs: { to: _vm.mainPageUrl } }, [
                  _vm.isMobile
                    ? _c("img", {
                        attrs: {
                          src: _vm.mobileLogotypePath,
                          alt: _vm.mainPageAlt
                        }
                      })
                    : _c("img", {
                        attrs: { src: _vm.logotypePath, alt: _vm.mainPageAlt }
                      })
                ])
              ],
              1
            ),
            _c("single-page-part", { attrs: { pagePart: _vm.warningPart } }),
            _c("language-switcher", { attrs: { id: "LS-FOO" } })
          ],
          1
        ),
        _c("div", { staticClass: "footer__content" }, [
          _c(
            "div",
            [
              _c("single-page-part", { attrs: { pagePart: _vm.smallMenuPart } })
            ],
            1
          ),
          _c(
            "div",
            [
              _c("single-page-part", {
                attrs: { pagePart: _vm.middleMenuPart }
              })
            ],
            1
          ),
          _c(
            "div",
            [_c("single-page-part", { attrs: { pagePart: _vm.bigMenuPart } })],
            1
          ),
          _c(
            "div",
            [
              _c("single-page-part", { attrs: { pagePart: _vm.helpPart } }),
              _c(
                "v-form",
                {
                  ref: "subscribeNewsletterForm",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.subscribeNewsletterForm,
                    callback: function($$v) {
                      _vm.subscribeNewsletterForm = $$v
                    },
                    expression: "subscribeNewsletterForm"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "footer__subscribe" },
                    [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("front.footer.titles.subscribe_newsletter")
                          )
                        )
                      ]),
                      _c(
                        "div",
                        { staticClass: "subscribe" },
                        [
                          _c("v-text-field", {
                            staticClass: "email",
                            attrs: {
                              type: "email",
                              rules: _vm.newsletterSubscriptionEmailRules,
                              placeholder: _vm.$t(
                                "front.footer.placeholder.email"
                              ),
                              "hide-details": "auto",
                              required: "",
                              autocomplete: "off"
                            },
                            model: {
                              value: _vm.newsletterSubscriptionEmail,
                              callback: function($$v) {
                                _vm.newsletterSubscriptionEmail = $$v
                              },
                              expression: "newsletterSubscriptionEmail"
                            }
                          }),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn btn-primary",
                              on: { click: _vm.subscribeNewsletter }
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t("front.footer.button.subscribe")
                                  ) +
                                  "\n                            "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c("v-checkbox", {
                        attrs: {
                          rules: _vm.regulationsCheckRules,
                          "hide-details": "auto",
                          label: _vm.$t("front.footer.titles.years_old")
                        },
                        model: {
                          value: _vm.regulationsCheck,
                          callback: function($$v) {
                            _vm.regulationsCheck = $$v
                          },
                          expression: "regulationsCheck"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "footer__partners" },
          [_c("single-page-part", { attrs: { pagePart: _vm.partnersPart } })],
          1
        ),
        _c(
          "div",
          { staticClass: "footer__copyright" },
          [_c("single-page-part", { attrs: { pagePart: _vm.copyrightPart } })],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }